"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILLING_ADDON_INFO = exports.isBillingAddonSlug = exports.BILLING_ADDON_SLUGS = exports.BillingAddonSlug = void 0;
/**
 * Stripe product metadata.slug values for X Integration add-ons (PRD Epic 7).
 * These are line items on the company's existing subscription — not base plans.
 */
var BillingAddonSlug;
(function (BillingAddonSlug) {
    BillingAddonSlug["X_INTEGRATION"] = "x-integration";
    BillingAddonSlug["X_LINK_POSTING"] = "x-link-posting";
})(BillingAddonSlug || (exports.BillingAddonSlug = BillingAddonSlug = {}));
exports.BILLING_ADDON_SLUGS = Object.values(BillingAddonSlug);
const isBillingAddonSlug = (slug) => exports.BILLING_ADDON_SLUGS.includes(slug);
exports.isBillingAddonSlug = isBillingAddonSlug;
/** Display metadata for billing UI (amounts are informational; Stripe prices are source of truth). */
exports.BILLING_ADDON_INFO = {
    [BillingAddonSlug.X_INTEGRATION]: {
        name: "X Integration",
        description: "Connect and publish to X for this client account. Required before link posting.",
        suggestedMonthlyUsd: 35,
    },
    [BillingAddonSlug.X_LINK_POSTING]: {
        name: "X Link Posting",
        description: "Allow links in X posts. X charges more for link posts; this add-on covers that volume.",
        suggestedMonthlyUsd: 25,
    },
};
